import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[store/page.js]");
const defaultSettings = require("@/settings.js");

const getDefaultState = () => {
  return {
    loading: true,
    isProcessLoading: false,
    process: 0,
    loadingClass: "", // "smb-process-style"
    style: defaultSettings.style,
    type: defaultSettings.type,
    topSelectedMenu: "",

    askBeforeLeave: false,
  };
};

const state = getDefaultState();
let loading_flag = "";

const mutations = {
  SET_LOADING(state, { value, flag }) {
    // if (loading_route != "") {
    //   if (loading_route != router.history.current.fullPath && !value) {
    //     return;
    //   }
    // }
    if (typeof flag != "undefined") {
      if (!value) {
        if (loading_flag != "" && loading_flag != flag) {
          log("@mu(SET_LOADING) prevent", value, flag, "correct->", loading_flag);
          return;
        } else {
          loading_flag = "";
        }
      } else {
        loading_flag = flag;
      }
    } else {
      loading_flag = "";
    }
    state.loading = value;
    log("@mu(SET_LOADING) state", value, flag, "correct->", loading_flag);
  },
  SET_LOADING_STYLE(state, arr) {
    state.isProcessLoading = arr[0] || false;
    state.process = arr[1] || 0;
    state.loadingClass = arr[2] || "";
    log("@mu(SET_LOADING) state", state.isProcessLoading);
  },
  SET_TOP_MENU(state, value) {
    state.topSelectedMenu = value;
  },
};

const actions = {
  setLoading: ({ commit }, { value, flag }) => {
    commit("SET_LOADING", { value, flag });
    // if (!value) {
    //   setTimeout(function () {
    //     commit('SET_LOADING', value)
    //   }, 100)
    // } else {
    //   commit('SET_LOADING', value)
    // }
    return value;
  },
  setLoadingStyle: ({ commit }, arr) => {
    commit("SET_LOADING_STYLE", arr);
    return arr;
  },
  setTopMenu: ({ commit }, value) => {
    commit("SET_TOP_MENU", value);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
